var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyBanknoteExchange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 22,
    viewBox: "0 0 20 22",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.5 21.5-1.5-1.5 1.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 20h2c1.6568542 0 3-1.3431458 3-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.5 2.5 1.5 1.5-1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 4h-2c-1.65685425 0-3 1.34314575-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 13v4.55415c0 .7985209-.6473291 1.44585-1.44585 1.44585h-8.1083c-.79852091 0-1.44585-.6473291-1.44585-1.44585v-5.1083c0-.7985209.64732909-1.44585 1.44585-1.44585h7.55415c.530433 0 1.0391408.2107137 1.4142136.5857864.3750727.3750728.5857864.8837806.5857864 1.4142136z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 15,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 8v-1.55415c0-.79852091.6473291-1.44585 1.44585-1.44585h7.55415c1.1045695 0 2 .8954305 2 2v4.55415c0 .3834633-.1523302.7512209-.4234797 1.0223703-.2711494.2711495-.638907.4234797-1.0223703.4234797h-2.55415"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.43934 7.93934c.3788654-.37929685.9313565-.52756111 1.4492173-.38890602.5178609.13865509.9223536.54314786 1.0610087 1.06100867.1386551.51786082-.0096092 1.070352-.388906 1.44921735"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBanknoteExchange);
export default __webpack_public_path__ + "static/media/money-banknote-exchange.0bf6487fa5fed7359bd421f4109b444a.svg";
export { ForwardRef as ReactComponent };